export const navbarThemeToTailwindClasses = (theme: any) => {
    return ["navbar", "@4xl:block","flex", "gap-4", "w-full", "justify-between", "items-center", "py-4", "px-8"];
};